let IrealMixin = {
  install(Vue, config) {
    // Mixins commun à tous les composants
    Vue.mixin({
      // Config accessible dans tous les composants
      data() {
        return { CONFIG: config };
      },
      // Traduction facilitée pour les éléments des expériences
      methods: {
        tx(key) {
          let identifier = this.$store.state.experience.identifier;
          return this.$t(`${identifier}_${key}`);
        },
        base_img(){
          console.log(CONFIG)
        }
      }
    });
  }
};
export default IrealMixin;
